import { render } from "./NewsPromoTag.vue?vue&type=template&id=789bcec2&scoped=true"
import script from "./NewsPromoTag.vue?vue&type=script&lang=js"
export * from "./NewsPromoTag.vue?vue&type=script&lang=js"

import "./NewsPromoTag.vue?vue&type=style&index=0&id=789bcec2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789bcec2"]])

export default __exports__